export const STORAGE_KEYS = {
  // ACCESS_TOKEN and REFRESH_TOKEN are now HttpOnly cookies (managed by backend)
  FIRSTNAME: "firstname",
  LASTNAME: "lastname",
  ROLE: "role",
  IS_MANAGER: "isManager",
  BRANCH_ID: "branch_id",
  GROUP_ID: "group_id",
  GROUP_DETAILS: "group_details",
  GROUP_NAME: "group_name",
  ADMIN_BRANCHES: "admin_branches",
  IS_SUPER_ADMIN: "isSuperAdmin",
  TEACHER_ACTIVE_GR_ID: "teacherActiveGrId",
  TEACHER_MAIN_TAB: "teacherMainTab",
  SUPER_USER: "superuser",
  IS_IT_SUPPORT: "isItSupport",
  IS_DEVELOPER: "isDeveloper",
  HEAD_ACCESS: "headAccess",
  USER_ID: "userID",
  PHONE: "phone",
};

export const LOGOUT_KEYS = [
  // Tokens are now HttpOnly cookies (cleared by /auth/signout)
  STORAGE_KEYS.FIRSTNAME,
  STORAGE_KEYS.LASTNAME,
  STORAGE_KEYS.ROLE,
  STORAGE_KEYS.IS_MANAGER,
  STORAGE_KEYS.BRANCH_ID,
  STORAGE_KEYS.GROUP_ID,
  STORAGE_KEYS.GROUP_DETAILS,
  STORAGE_KEYS.GROUP_NAME,
  STORAGE_KEYS.ADMIN_BRANCHES,
  STORAGE_KEYS.IS_SUPER_ADMIN,
  STORAGE_KEYS.TEACHER_ACTIVE_GR_ID,
  STORAGE_KEYS.TEACHER_MAIN_TAB,
  STORAGE_KEYS.SUPER_USER,
  STORAGE_KEYS.IS_IT_SUPPORT,
  STORAGE_KEYS.IS_DEVELOPER,
  STORAGE_KEYS.HEAD_ACCESS,
  STORAGE_KEYS.USER_ID,
  STORAGE_KEYS.PHONE,
];

export function storageGet(key, fallback = null) {
  try {
    return localStorage.getItem(key) ?? fallback;
  } catch {
    return fallback;
  }
}

export function storageGetJSON(key, fallback = null) {
  try {
    const raw = localStorage.getItem(key);
    return raw !== null ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
}

export function storageSet(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch {
    // storage full or unavailable
  }
}

export function storageSetJSON(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // storage full or unavailable
  }
}

export function storageRemove(key) {
  try {
    localStorage.removeItem(key);
  } catch {
    // storage unavailable
  }
}

export function storageRemoveMany(keys) {
  keys.forEach((key) => storageRemove(key));
}
